import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1dc29254"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

import BasicCard from '@/components/atomic/BasicCard.vue'
import type { WorkspaceMetadata } from '@/core/interfaces/WorkspaceMetadata.ts'
// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'CardList',
  props: {
  elements: Array<WorkspaceMetadata>
},
  setup(__props) {

const props = __props;





return (_ctx: any,_cache: any) => {
  return (__props.elements)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.elements, (e) => {
          return (_openBlock(), _createElementBlock("li", {
            key: e.id
          }, [
            _createVNode(BasicCard, {
              id: e.id,
              name: e.name,
              description: e.description,
              owner: e.owner,
              deployingDate: e.deployingDate,
              dataSize: parseInt(e.dataSize)
            }, null, 8, ["id", "name", "description", "owner", "deployingDate", "dataSize"])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})